import { render, staticRenderFns } from "./organization-gdpr-roadmap-view.vue?vue&type=template&id=326c93b5&scoped=true"
import script from "./organization-gdpr-roadmap-view.vue?vue&type=script&lang=js"
export * from "./organization-gdpr-roadmap-view.vue?vue&type=script&lang=js"
import style0 from "./organization-gdpr-roadmap-view.vue?vue&type=style&index=0&id=326c93b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326c93b5",
  null
  
)

export default component.exports